import React from 'react';
import { Notification } from './Notification';
import { useNotificationContext } from './NotificationContext';
export const NotificationWrapper = () => {
  const {
    show,
    onCloseClick,
    message,
    action,
    onShow
  } = useNotificationContext();
  return /*#__PURE__*/React.createElement(Notification, {
    show: show,
    onCloseClick: onCloseClick,
    message: message,
    action: action,
    onShow: onShow
  });
};
//# sourceMappingURL=NotificationWrapper.js.map